import { ChallengeTopic } from "@/challenges/utils/interfaces";
import ChallengeDetailCard from "./ChallengeDetailCard";
import { challengesListCss } from "./ChallengesListSectionContainer.style";

interface ChallengesListSectionContainerProps {
  isHomeVersion?: boolean | undefined;
  topics: ChallengeTopic[];
}

const ChallengesListSectionContainer = ({
  isHomeVersion = false,
  topics,
}: ChallengesListSectionContainerProps) => {
  return (
    <div css={challengesListCss}>
      {topics.map((topic) => (
        <ChallengeDetailCard
          key={topic.topic_id}
          isHomeVersion={isHomeVersion}
          topic={topic}
        />
      ))}
    </div>
  );
};

export default ChallengesListSectionContainer;
